import { Component, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-section-valoracion',
  templateUrl: './section-valoracion.component.html',
  styleUrls: ['./section-valoracion.component.css']
})
export class SectionValoracionComponent implements OnChanges {

  @Input() public tipoValoracion : string = "";

  constructor() { }

  ngOnChanges() {
    this.getTipoValoracion();
  }

  private async getTipoValoracion() {
    try {
      await this.tipoValoracion;
    } catch (exception) {
      console.log(exception);
    }
  }

}